var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,99V25.5L1.2,25v-0.1C1.5,24.6,22.3,1,50.7,1c16.8,0,32.7,8.1,47.6,24.1l0.8,0.8V99L1,99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7,1.9c14.2,0,30.3,5.9,46.9,23.8l0.5,0.6v71.8H1.9V25.8l0.1-0.3C2.1,25.5,22.4,1.9,50.7,1.9 M50.7,0L50.7,0 C21.9,0,1.5,23.2,0.6,24.2l-0.2,0.2l-0.1,0.2L0.2,25L0,25.4V100h100V25.5L99.5,25l-0.2-0.2l-0.3-0.3C83.9,8.2,67.7,0,50.7,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE01);
export default __webpack_public_path__ + "static/media/e_01.3f3dc7a60162d43bc773b37436ac1fce.svg";
export { ForwardRef as ReactComponent };